module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAPCAYAAAA2yOUNAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAI9JREFUeNpi/J/GAAJsUPyFAQtggkquAOK9QMyPS1EvEAcCsRkQ78KmEKSoG4gfQflYFTJBFdiiKdyOrJAJSqMrtERWyIRkKk6FTGhuBCmIRuKDFHahK5ID4kVI/FNAXMaCpuAwlIYpcAPij0yEFMAcjlcBTFEpPgUgAHJTMRBLQzGGApiiX0AcgS8VAAQYAF1PJQlWgdIqAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// /usr/local/app/src/assets/Template/images/bg-404-link.png
// module id = ../../../../../src/assets/Template/images/bg-404-link.png
// module chunks = 2